import { format } from 'date-fns';
import { client } from '../../../../services/apiClient';
import {
  AnswerFeaturesResponse,
  LatestProductsResponse,
  PromptFanoutResponse,
  PromptFeaturesSummaryItem,
} from '../../../../models/monitor/ResponseFeatures';

const DATA_ENDPOINT = '/monitor/data';

const formatDate = (date: Date | string): string =>
  date instanceof Date ? format(date, 'yyyy-MM-dd') : date;

export const getPromptFanout = async (
  monitorId: number,
  from: Date | string,
  to: Date | string,
  models?: string[],
  limit?: number
): Promise<PromptFanoutResponse> => {
  const queryParams = new URLSearchParams();
  if (models && models.length > 0) {
    queryParams.append('models', models.join(','));
  }
  if (limit) {
    queryParams.append('limit', limit.toString());
  }
  const queryString = queryParams.toString();

  const { data } = await client(true, true).get<PromptFanoutResponse>(
    `${DATA_ENDPOINT}/fanout/${monitorId}/${formatDate(from)}/${formatDate(to)}${
      queryString ? `?${queryString}` : ''
    }`
  );
  return data;
};

export const getLatestProducts = async (
  monitorId: number,
  from: Date | string,
  to: Date | string,
  models?: string[],
  limit?: number
): Promise<LatestProductsResponse> => {
  const queryParams = new URLSearchParams();
  if (models && models.length > 0) {
    queryParams.append('models', models.join(','));
  }
  if (limit) {
    queryParams.append('limit', limit.toString());
  }
  const queryString = queryParams.toString();

  const { data } = await client(true, true).get<LatestProductsResponse>(
    `${DATA_ENDPOINT}/features/products/${monitorId}/${formatDate(from)}/${formatDate(to)}${
      queryString ? `?${queryString}` : ''
    }`
  );
  return data;
};

export const getAnswerFeatures = async (monitorDataId: number): Promise<AnswerFeaturesResponse> => {
  const { data } = await client(true, true).get<AnswerFeaturesResponse>(
    `${DATA_ENDPOINT}/features/answer/${monitorDataId}`
  );
  return data;
};

export const getFeaturesSummary = async (
  projectId: number,
  from: Date | string,
  to: Date | string,
  models?: string[],
  promptIds?: number[]
): Promise<PromptFeaturesSummaryItem[]> => {
  const queryParams = new URLSearchParams();
  if (models && models.length > 0) {
    queryParams.append('models', models.join(','));
  }
  if (promptIds && promptIds.length > 0) {
    queryParams.append('promptIds', promptIds.join(','));
  }
  const queryString = queryParams.toString();

  const { data } = await client(true, true).get<PromptFeaturesSummaryItem[]>(
    `${DATA_ENDPOINT}/features/summary/${projectId}/${formatDate(from)}/${formatDate(to)}${
      queryString ? `?${queryString}` : ''
    }`
  );
  return data;
};
